/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import typography from "ui/style/typography.module.scss";
import styles from "./StepperItem.module.scss";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import classnames from "classnames";

export interface Props {
    title: string;
    description: string;
    icon: IconDefinition;
    state: "error" | "warning" | "success";
    selected: boolean;
}

const StepperItem: React.FC<Props> = ({description, title, icon, state, selected}) => {
    return (
        <div className={classnames(styles.container, {
            [styles.containerSelected]: selected
        })}>
            <div>
                <p className={typography.stepperTitle}>{title}</p>
                <p className={typography.stepperBody}>{description}</p>
            </div>
            <div className={classnames(styles.iconContainer, {
                [styles.iconGreen]: state === "success",
                [styles.iconRed]: state === "error",
                [styles.iconYellow]: state === "warning",
            })}>
                <FontAwesomeIcon size={"lg"} icon={icon}/>
            </div>
        </div>
    );
}

export default StepperItem;